export function sqlString(value: unknown): string {
  if (value === null || value === undefined) return 'NULL';
  const s = String(value);
  return `'${s.replace(/'/g, "''")}'`;
}

export function sqlNumber(value: unknown): string {
  if (value === null || value === undefined || value === '') return 'NULL';
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) ? String(n) : 'NULL';
}
